/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StockDetailByIdQueryVariables = {|
  id?: ?string
|};
export type StockDetailByIdQueryResponse = {|
  +allPoliticians: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +politicianImage: ?string,
        +dob: any,
        +birthplace: string,
        +age: number,
        +education: string,
        +currentPosition: string,
        +almaMater: string,
        +upcoming: boolean,
        +upcomingStocks: number,
        +upcomingStocksUsed: number,
        +upcomingStocksPercentage: ?number,
        +upcomingStocksSubscribed: ?number,
        +party: {|
          +id: string,
          +partyName: string,
          +partyImage: ?string,
        |},
        +tags: ?$ReadOnlyArray<?string>,
        +region: {|
          +regionName: string
        |},
        +price: number,
        +rank: ?number,
        +relatedPoliticians: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +name: string,
              +politicianImage: ?string,
              +price: number,
              +stockhistory: {|
                +edges: $ReadOnlyArray<?{|
                  +node: ?{|
                    +created: any,
                    +updatedPrice: number,
                  |}
                |}>
              |},
            |}
          |}>
        |},
        +totalShare: number,
        +openShare: number,
        +lockedShares: number,
        +marketCap: number,
        +purchaseCap: number,
        +buy: number,
        +sell: number,
        +hold: number,
        +buySellHold: ?boolean,
        +politicianassets: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +totalAssets: number,
              +immovableAssets: ?number,
              +movableAssets: ?number,
              +investments: ?number,
            |}
          |}>
        |},
        +politiciantimelines: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +year: string,
              +govt: string,
              +workedAs: string,
            |}
          |}>
        |},
      |}
    |}>
  |}
|};
export type StockDetailByIdQuery = {|
  variables: StockDetailByIdQueryVariables,
  response: StockDetailByIdQueryResponse,
|};
*/


/*
query StockDetailByIdQuery(
  $id: ID
) {
  allPoliticians(id: $id) {
    edges {
      node {
        id
        name
        politicianImage
        dob
        birthplace
        age
        education
        currentPosition
        almaMater
        upcoming
        upcomingStocks
        upcomingStocksUsed
        upcomingStocksPercentage
        upcomingStocksSubscribed
        party {
          id
          partyName
          partyImage
        }
        tags
        region {
          regionName
          id
        }
        price
        rank
        relatedPoliticians {
          edges {
            node {
              id
              name
              politicianImage
              price
              stockhistory {
                edges {
                  node {
                    created
                    updatedPrice
                    id
                  }
                }
              }
            }
          }
        }
        totalShare
        openShare
        lockedShares
        marketCap
        purchaseCap
        buy
        sell
        hold
        buySellHold
        politicianassets {
          edges {
            node {
              totalAssets
              immovableAssets
              movableAssets
              investments
              id
            }
          }
        }
        politiciantimelines {
          edges {
            node {
              id
              year
              govt
              workedAs
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "politicianImage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dob",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "birthplace",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "age",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "education",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentPosition",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "almaMater",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcoming",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcomingStocks",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcomingStocksUsed",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcomingStocksPercentage",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcomingStocksSubscribed",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "PartyNode",
  "kind": "LinkedField",
  "name": "party",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partyImage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rank",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedPrice",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalShare",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openShare",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedShares",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketCap",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "purchaseCap",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buy",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sell",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hold",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buySellHold",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAssets",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "immovableAssets",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "movableAssets",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "investments",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "PoliticianTimeLineNodeConnection",
  "kind": "LinkedField",
  "name": "politiciantimelines",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PoliticianTimeLineNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PoliticianTimeLineNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "year",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "govt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workedAs",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StockDetailByIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PoliticiansNodeConnection",
        "kind": "LinkedField",
        "name": "allPoliticians",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticiansNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PoliticiansNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegionNode",
                    "kind": "LinkedField",
                    "name": "region",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PoliticiansNodeConnection",
                    "kind": "LinkedField",
                    "name": "relatedPoliticians",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PoliticiansNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PoliticiansNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StockHistoryNodeConnection",
                                "kind": "LinkedField",
                                "name": "stockhistory",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StockHistoryNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StockHistoryNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v21/*: any*/),
                                          (v22/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PoliticianAssetsNodeConnection",
                    "kind": "LinkedField",
                    "name": "politicianassets",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PoliticianAssetsNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PoliticianAssetsNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v36/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StockDetailByIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PoliticiansNodeConnection",
        "kind": "LinkedField",
        "name": "allPoliticians",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticiansNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PoliticiansNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegionNode",
                    "kind": "LinkedField",
                    "name": "region",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PoliticiansNodeConnection",
                    "kind": "LinkedField",
                    "name": "relatedPoliticians",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PoliticiansNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PoliticiansNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StockHistoryNodeConnection",
                                "kind": "LinkedField",
                                "name": "stockhistory",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StockHistoryNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StockHistoryNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v21/*: any*/),
                                          (v22/*: any*/),
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PoliticianAssetsNodeConnection",
                    "kind": "LinkedField",
                    "name": "politicianassets",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PoliticianAssetsNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PoliticianAssetsNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v36/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a7018a8999288674e5c600801a37bdf0",
    "id": null,
    "metadata": {},
    "name": "StockDetailByIdQuery",
    "operationKind": "query",
    "text": "query StockDetailByIdQuery(\n  $id: ID\n) {\n  allPoliticians(id: $id) {\n    edges {\n      node {\n        id\n        name\n        politicianImage\n        dob\n        birthplace\n        age\n        education\n        currentPosition\n        almaMater\n        upcoming\n        upcomingStocks\n        upcomingStocksUsed\n        upcomingStocksPercentage\n        upcomingStocksSubscribed\n        party {\n          id\n          partyName\n          partyImage\n        }\n        tags\n        region {\n          regionName\n          id\n        }\n        price\n        rank\n        relatedPoliticians {\n          edges {\n            node {\n              id\n              name\n              politicianImage\n              price\n              stockhistory {\n                edges {\n                  node {\n                    created\n                    updatedPrice\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n        totalShare\n        openShare\n        lockedShares\n        marketCap\n        purchaseCap\n        buy\n        sell\n        hold\n        buySellHold\n        politicianassets {\n          edges {\n            node {\n              totalAssets\n              immovableAssets\n              movableAssets\n              investments\n              id\n            }\n          }\n        }\n        politiciantimelines {\n          edges {\n            node {\n              id\n              year\n              govt\n              workedAs\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aa9c285278cb5e73513a8120420e44a0';

module.exports = node;
